// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateDisplayCreditMemoDisabled = isDisabled => ({
    isDisabled,
    type: actions.UPDATE_CREDIT_MEMO_DISPLAY_DISABLED
});



// WEBPACK FOOTER //
// ./src/reports/credit-memo/action-creators/is-display-credit-memo-disabled.js